// Generated by ReScript, PLEASE EDIT WITH CARE

function getPlayer(element) {
  return element.player;
}
export { getPlayer };
/* No side effect */